import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePermissionStore = defineStore('permission', () => {
  const permissions = ref<string[]>([])

  // 设置权限列表（登录/切换租户后调用）
  const setPermissions = (perms: string[]) => {
    permissions.value = perms
    localStorage.setItem('permissions', JSON.stringify(perms))
  }

  // 从 localStorage 加载权限（页面刷新时）
  const loadPermissions = () => {
    const stored = localStorage.getItem('permissions')
    if (stored) {
      try {
        permissions.value = JSON.parse(stored)
      } catch {
        permissions.value = []
      }
    }
  }

  const isTenantAdmin = (): boolean => {
    const stored = localStorage.getItem('user')
    if (!stored) return false
    try {
      const user = JSON.parse(stored)
      return user?.roleCode === 'TENANT_ADMIN' || user?.role_code === 'TENANT_ADMIN'
    } catch {
      return false
    }
  }

  // 检查是否拥有指定权限
  const hasPermission = (code: string): boolean => {
    return permissions.value.includes('*') || permissions.value.includes(code) || isTenantAdmin()
  }

  // 检查是否拥有任一权限
  const hasAnyPermission = (...codes: string[]): boolean => {
    return permissions.value.includes('*') || isTenantAdmin() || codes.some(code => permissions.value.includes(code))
  }

  // 清除权限（登出时调用）
  const clearPermissions = () => {
    permissions.value = []
    localStorage.removeItem('permissions')
  }

  return { permissions, setPermissions, loadPermissions, hasPermission, hasAnyPermission, clearPermissions }
})
